import React from 'react';

export default function IsNotHype(props) {
    const {apiData} = props;
    return (
        <article className='is-not-hype'>
            <p dangerouslySetInnerHTML={{__html: apiData.is_not_hype_text}}></p>
        </article>
    )
}